<script>
import { FormWizard, TabContent } from "vue-form-wizard";

import sacrificer_info from "@/components/pilgrimages/sacrificer_info";
import beneficiary_info from "@/components/pilgrimages/beneficiary_info";
import passport_info from "@/components/pilgrimages/passport_info";
import emergency_info from "@/components/pilgrimages/emergency_info";
import attachmnet from "@/components/pilgrimages/attachment";

import { swal } from "../../../helpers/handle_error";
import AlertError from "@/components/alert_error";
import VueQRCodeComponent from "vue-qrcode-component";
import html2canvas from "html2canvas";
import SacrificerModel from "../../../model/step-pilgrimage/sacrificer";
import PilgrimageServices from "../../../services/Pilgrimage";
import unitTestPilgrimage from "../../../helpers/unit_test_step_pilgrimage";

import { mapActions } from "vuex";

export default {
  components: {
    FormWizard,
    TabContent,
    sacrificer_info,
    beneficiary_info,
    passport_info,
    emergency_info,
    attachmnet,
    AlertError,
    "qr-code": VueQRCodeComponent,
  },
  data() {
    return {
      //Page errors.
      errors: [],

      isPrintedInformation: false,
      fullName: "",
      Id: "",
      date: "",
      qrCodeContent: "",
      showAlert: false,
    };
  },
  methods: {
    ...mapActions("authPilgrimage", ["logOut"]),
    handleError(error) {
      this.showAlert = true;
      if (error.response.status == 422)
        this.errors = Object.values(error.response.data.errors);
      else
        this.errors = [
          `Error Code : ${error.response.status}  Message : ${error.response.data.message}`,
        ];
    },
    resetForm() {
      this.errors = [];
      swal.close();
    },
    onComplete: function () {
      swal.loading();

      var data = new SacrificerModel(
        this.$refs["sacrificer_info"],
        this.$refs["beneficiary_info"],
        this.$refs["passport_info"],
        this.$refs["emergency_info"],
        this.$refs["attachmnet"]
      );

      PilgrimageServices.addSacrificer(data.toFormData())
        .then((response) => {
          this.fullName = response.data.data.fullName;
          this.Id = response.data.data.id;
          this.date = response.data.data.date;

          this.qrCodeContent = JSON.stringify({
            Id: this.Id,
            fullName: this.fullName,
            date: this.date,
          });

          this.isPrintedInformation = true;
          this.resetForm();
        })
        .catch((error) => {
          this.handleError(error);
          swal.close();
        });
    },
    validateStep(name) {
      var refToValidate = this.$refs[name];
      return refToValidate.validate();
    },
    mergePartialModels(model, isValid) {
      if (isValid) {
        // merging each step model into the final model
        this.finalModel = Object.assign({}, this.finalModel, model);
      }
    },
    // print card
    async printThis() {
      const el = this.$refs.printcontent;
      const options = { type: "dataURL" };
      const printCanvas = await html2canvas(el, options);
      const link = document.createElement("a");
      link.setAttribute("download", this.Id + ".jpg");
      link.setAttribute(
        "href",
        printCanvas.toDataURL("image/jpg").replace("image/jpg", "image/octet-stream")
      );
      link.click();
    },
    tryLogout() {
      this.logOut().finally(() => {
        this.$router.push({ name: "pilgrimage.login" });
      });
    },
  },
  mounted() {
    if (process.env.NODE_ENV == "development") {
      unitTestPilgrimage(this.$refs);
    }
  },
};
</script>

<template>
  <div style="overflow-x: hidden">
    <!-- Features start -->
    <img class="img-wallpaper" src="@/assets/images/wallpaper3.png" alt="" />
    <section
      class="section"
      id="features"
      style="min-height: calc(100vh - 163px); padding-top: 40px"
    >
      <div class="col-12">
        <button
          style="position: absolute; left: 10px; top: 10px"
          class="btn btn-secondary"
          @click="tryLogout"
        >
          تسجيل الخروج
        </button>
      </div>

      <AlertError :showDismissibleAlert="showAlert" :errors="errors"></AlertError>

      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="text-center mb-5">
              <a href="/home/index"><h4>منصة امتنان</h4></a>
              <h5>
                <div class="small-title">استمارة الحج</div>
              </h5>
            </div>
          </div>
          <div v-if="isPrintedInformation" class="text-center print-cover">
            <div class="card-print con-print text-center" ref="printcontent">
              <h5>استمارة الحج</h5>
              <p><strong>الاسم :</strong> {{ fullName }}</p>
              <p><strong>تاريخ التقديم :</strong> {{ date }}</p>
              <p><strong>رقم الاستمارة :</strong> {{ Id }}</p>
              <qr-code class="qr-code" :text="qrCodeContent"></qr-code>
              <hr />
              <div class="">
                <p class="mb-1">هيأة الحشد الشعبي</p>
                <p class="mb-0">المديرية العامة للعلاقات والخدمات الاجتماعية</p>
              </div>
            </div>
            <button
              type="button"
              id="btn3"
              @click="printThis"
              class="btn bg-color-blue font-color-white btn-sm mt-2"
            >
              حفظ وصل التسجيل
            </button>

            <div class="col-12">
              <a href="/alhaj">
                <button
                  type="button"
                  class="btn btn-secondary font-color-white btn-sm mt-3"
                >
                  إنشاء استمارة جديدة
                </button>
              </a>
            </div>
          </div>
          <div v-else class="col-lg-12">
            <div class="mb-5">
              <form-wizard
                color="#556ee6"
                error-color="#a94442"
                step-size="xs"
                back-button-text="السابق"
                next-button-text="التالي"
                finish-button-text="ارسال البيانات"
                @on-complete="onComplete"
              >
                <tab-content
                  title="معلومات المضحي"
                  icon="mdi mdi-chevron-double-left"
                  :before-change="() => validateStep('sacrificer_info')"
                >
                  <sacrificer_info
                    ref="sacrificer_info"
                    @on-validate="mergePartialModels"
                  ></sacrificer_info>
                </tab-content>
                <tab-content
                  title="معلومات الحاج"
                  icon="mdi mdi-chevron-double-left"
                  :before-change="() => validateStep('beneficiary_info')"
                >
                  <beneficiary_info
                    ref="beneficiary_info"
                    @on-validate="mergePartialModels"
                  ></beneficiary_info>
                </tab-content>
                <tab-content
                  title="معلومات جواز سفر الحاج"
                  icon="mdi mdi-chevron-double-left"
                  :before-change="() => validateStep('passport_info')"
                >
                  <passport_info
                    ref="passport_info"
                    @on-validate="mergePartialModels"
                  ></passport_info>
                </tab-content>
                <tab-content
                  title="معلومات الطوارئ"
                  icon="mdi mdi-chevron-double-left"
                  :before-change="() => validateStep('emergency_info')"
                >
                  <emergency_info
                    ref="emergency_info"
                    @on-validate="mergePartialModels"
                  ></emergency_info>
                </tab-content>
                <tab-content
                  title="المرفقات"
                  icon="mdi mdi-chevron-double-left"
                  :before-change="() => validateStep('attachmnet')"
                >
                  <attachmnet
                    ref="attachmnet"
                    @on-validate="mergePartialModels"
                  ></attachmnet>
                </tab-content>
                <tab-content
                  title="ارسال البيانات"
                  icon="mdi mdi-checkbox-marked-circle-outline"
                >
                  <h4 class="my-5 text-center">
                    اضغط على ( ارسال البيانات ) لارسال الاستمارة .
                  </h4>
                </tab-content>
              </form-wizard>
            </div>
          </div>
        </div>
        <!-- end row -->
      </div>
      <!-- end container -->
    </section>
    <!-- Features end -->

    <!-- Footer start -->
    <footer class="landing-footer">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <img src="@/assets/images/logo.png" alt height="25" />
            <span class="mx-2">منصة امتنان</span>
          </div>
          <div class="col-md-6">
            <p class="mt-1 text-md-end d-sm-block mb-0">
              {{ new Date().getFullYear() }} © جميع الحقوق محفوظة
            </p>
          </div>
        </div>
      </div>
    </footer>
    <!-- Footer end -->
  </div>
</template>
